/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelPaymentBody
 */
export interface CancelPaymentBody {
    /**
     * 
     * @type {string}
     * @memberof CancelPaymentBody
     */
    traceId: string;
}

/**
 * Check if a given object implements the CancelPaymentBody interface.
 */
export function instanceOfCancelPaymentBody(value: object): value is CancelPaymentBody {
    if (!('traceId' in value) || value['traceId'] === undefined) return false;
    return true;
}

export function CancelPaymentBodyFromJSON(json: any): CancelPaymentBody {
    return CancelPaymentBodyFromJSONTyped(json, false);
}

export function CancelPaymentBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelPaymentBody {
    if (json == null) {
        return json;
    }
    return {
        
        'traceId': json['traceId'],
    };
}

export function CancelPaymentBodyToJSON(json: any): CancelPaymentBody {
    return CancelPaymentBodyToJSONTyped(json, false);
}

export function CancelPaymentBodyToJSONTyped(value?: CancelPaymentBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'traceId': value['traceId'],
    };
}

